var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyberSecurity1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.851 7.57153C25.6551 7.89707 22.8493 6.81737 17.9255 4.04639C13.3046 7.17961 10.4892 7.99276 5 7.57153C5.46603 20.0878 8.21491 25.0229 17.9255 31.0725C27.8382 25.41 31.8519 21.125 30.851 7.57153Z",
    fill: "white",
    stroke: "#363C40",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2632 15.2105V15.2105C14.5655 15.2105 14 15.7761 14 16.4737V20.3684C14 21.473 14.8954 22.3684 16 22.3684H20C21.1046 22.3684 22 21.473 22 20.3684V16.4737C22 15.7761 21.4345 15.2105 20.7368 15.2105V15.2105M15.2632 15.2105V13.7368C15.2632 12.2253 16.4885 11 18 11V11C19.5115 11 20.7368 12.2253 20.7368 13.7368V15.2105M15.2632 15.2105H20.7368M18.2105 20.2632V19",
    stroke: "#363C40",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyberSecurity1);
export default __webpack_public_path__ + "static/media/cyber-security-1.2d0a94f3f5b431e28f4f615f993ee0a8.svg";
export { ForwardRef as ReactComponent };